// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-block-container {
    width: 100%;
    height: 400px;
    border: var(--border);
    border-radius: var(--border-radius);
}

.table-block-container .table-block-content-box {
    padding: 5px;
    height: calc(100% - 40px)
}

.table-block-modal {
    min-width: 80vw;
}

`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLTableBlock/ECLTableBlock.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".table-block-container {\r\n    width: 100%;\r\n    height: 400px;\r\n    border: var(--border);\r\n    border-radius: var(--border-radius);\r\n}\r\n\r\n.table-block-container .table-block-content-box {\r\n    padding: 5px;\r\n    height: calc(100% - 40px)\r\n}\r\n\r\n.table-block-modal {\r\n    min-width: 80vw;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
